import Produits from './Produits'
export default Produits
